<template>
    <div class="col-sm-4" v-if="can('*')">
        <div class="card">
            <div class="card-header">
                <h1 class="card-title">{{i18n("Profile")}}</h1>
            </div>
            <div class="card-body">
                <ul class="list-unstyled grid-list">
                    <router-link to="/profile" tag="li" v-if="can('*')">
                        <a href="#" title="">{{i18n("My profile")}}</a>
                    </router-link>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Profile",
    }
</script>

<style scoped>

</style>
